module.exports = __webpack_public_path__ + "static/flags/SV-5b37e847fe7de9181b015d15d5e09ebe.gif";